import { callApi, HTTPMethods } from '@/utils/api';
import KeycloakService from '@/services/keycloakService';
import { getApiUrl } from '@/utils/url';
import type { BlogResponse } from '@/types/api';

export default {
  /** GET /blogs/:id → BlogResponse | null (specific blog with translation, fr fallback). */
  async getBlogById(
    id: string,
    language?: string
  ): Promise<BlogResponse | null> {
    await KeycloakService.CallUpdate();
    const config = {
      'Content-Type': 'application/json',
    };
    const qs = language
      ? `?language=${encodeURIComponent(language.slice(0, 2))}`
      : '';
    return new Promise(resolve => {
      callApi({
        path: `${getApiUrl()}/blogs/${id}${qs}`,
        method: HTTPMethods.GET,
        options: config,
        successCallback: (result: BlogResponse | null) =>
          resolve(result ?? null),
        errorCallback: () => resolve(null),
      }).catch(() => resolve(null));
    });
  },

  /** GET /blogs → BlogResponse | null (latest blog by update_date). */
  async getLatestBlog(language?: string): Promise<BlogResponse | null> {
    await KeycloakService.CallUpdate();
    const config = {
      'Content-Type': 'application/json',
    };
    const qs = language
      ? `?language=${encodeURIComponent(language.slice(0, 2))}`
      : '';
    return new Promise((resolve) => {
      callApi({
        path: `${getApiUrl()}/blogs${qs}`,
        method: HTTPMethods.GET,
        options: config,
        successCallback: (result: BlogResponse | null) =>
          resolve(result ?? null),
        errorCallback: () => resolve(null),
      }).catch(() => resolve(null));
    });
  },
};
